import React, {Fragment, useState} from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {Button, Dialog} from '@material-ui/core';
import {CloseIcon, SearchIcon} from "../../../elements/svgIcons";
import GreenCheckIcon from "../../../elements/svgIcons/greenCheckIcon";
import {RingLoader} from "react-spinners";
import {isMobileBrowser} from "../../../vendors/utils/common";

interface Props {
    icon?: string | undefined,
    title?: string | undefined,
    description?: string | undefined,
    className?: string | undefined,
    inProcess?: boolean,
    open?: boolean,
    cancelable?: {
        buttonTitle: string,
        action?: any
    } | undefined,
    submit?: {
        buttonTitle: string,
        action: any
    } | undefined,
    secondaryBtnColor?: 'primary' | 'secondary' | 'default' | 'inherit'
}

const icons: {
    [key: string]: any
} = {
    lightbulb: <FontAwesomeIcon
        icon={['far', 'lightbulb']}
        className="d-flex align-self-center display-3"
    />,
    search: <SearchIcon className="search d-flex align-self-center display-3"/>,
    success: <GreenCheckIcon className="success d-flex align-self-center display-3"/>
};

const SuccessModal = (props: Props) => {
    const {icon, title, description, open = false, cancelable, submit, className, inProcess, secondaryBtnColor = 'default'} = props;
    const [modal, setModal] = useState(open);

    const toggle = () => setModal(!modal);

    return (
        <Fragment>
            <Dialog open={modal} className={`${className} success-modal`} onClose={cancelable?.action ||toggle}>
                <CloseIcon onClick={cancelable?.action || toggle} className='modal-close'/>
                <div className="modal-container text-center px-3 py-4 p-md-5">
                    <div className="avatar-icon-wrapper rounded-circle m-0">
                        {!inProcess && icon && <div
                            className="d-inline-flex position-relative justify-content-center p-0 rounded-circle avatar-icon bg-neutral-success text-success m-0">
                            {icons[icon] || <svg className={icon}/>}
                        </div>}
                        {inProcess &&
                        <div className={'d-inline-block mx-auto'}><RingLoader color={'var(--primary)'} loading={true}/>
                        </div>}
                    </div>
                    {title && <h4 className="c-m-title modal-title font-weight-bold mt-4 mb-4">{title}</h4>}
                    {description && <p className="c-m-description modal-description mb-0 mt-4 text-gray">{description}</p>}
                    {(cancelable || submit) && <div className="pt-4">
                        {submit && <Button
                            onClick={submit.action}
                            color='primary'
                            size={isMobileBrowser() ? 'small' : 'medium'}
                            variant="contained"
                            disabled={inProcess}
                            className={`mx-1 ${window.location.href.indexOf('find-lawyer') === -1 && 'and-lawyers-gradient-style'}`}>
                            <span className="btn-wrapper--label">{submit.buttonTitle}</span>
                        </Button>}
                        {cancelable && <Button
                            onClick={cancelable.action || toggle}
                            variant="outlined"
                            size={isMobileBrowser() ? 'small' : 'medium'}
                            color={secondaryBtnColor}
                            disabled={inProcess}
                            className={`mx-2 text-${secondaryBtnColor} font-weight-normal`}>
                            <span className="btn-wrapper--label">{cancelable.buttonTitle || 'Cancel'}</span>
                        </Button>}
                    </div>}
                </div>
            </Dialog>

        </Fragment>
    );
};

export default SuccessModal
